import { Injectable } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { Order } from '@cemex-core/cmx-api';
import { Store } from '@ngrx/store';
import { OneClickUpdateOrderAction } from '@ordersnproducts/modules/one-click-order/actions/one-click-orders.actions';
import { OneClickSelectOwnFreightPlantAction } from '@ordersnproducts/modules/one-click-order/actions/one-click-ownFreight-plants.actions';
import { State } from '@ordersnproducts/modules/one-click-order/reducers';
import { getOneClickSelectedOrder } from '@ordersnproducts/modules/one-click-order/selectors/one-click-orders.selector';
import { getOneClickOwnFreightPlants } from '@ordersnproducts/modules/one-click-order/selectors/one-click-ownFreight-plants.selector';
import { ConfigurableFormComponent } from '@ordersnproducts/modules/shared/modules/configurable-form/containers/configurable-form/configurable-form.component';
import { OnFieldChanged } from '@ordersnproducts/modules/shared/modules/configurable-form/models/on-field-changed';
import { filter, map, switchMap, take } from 'rxjs/operators';

@Injectable()
export class OneClickSetPlant implements OnFieldChanged {
  constructor(private store: Store<State>) {}

  onFieldChanged(value: number, formGroup: UntypedFormGroup, form: ConfigurableFormComponent): void {
    if (value) {
      this.store
        .select(getOneClickOwnFreightPlants)
        .pipe(
          filter((plants) => !!plants.length),
          take(1),
          map((plants) => plants.find((item) => item.plantId === value)),
          switchMap((plant) =>
            this.store.select(getOneClickSelectedOrder).pipe(
              take(1),
              map((order) => ({ order, plant })),
            ),
          ),
        )
        .subscribe(({ order, plant }) => {
          const orderUpdated = {
            ...order,
            items: order.items.map((item, index) => {
              if (index === form.mapItem['index']) {
                return {
                  ...item,
                  shippingSource: {
                    shippingSourceId: plant.plantId,
                  },
                };
              } else {
                return item;
              }
            }),
          } as Order;
          this.store.dispatch(new OneClickSelectOwnFreightPlantAction(plant));
          this.store.dispatch(new OneClickUpdateOrderAction(orderUpdated));
        });
    }
  }
}
